import axios from 'axios'
import qs from 'qs'
import { getToken } from '@/utils/auth'
import store from '@/store/index'
import md5 from 'js-md5';
// 在config.js文件中统一存放一些公共常量，方便之后维护
// import {baseURL} from './config.js'
// const baseURL = process.env.NODE_ENV === 'production' ? 'http://xzlm.bijingauto.cn/api/':  'http://xzlm.bijingauto.cn/api/';  //https://jxapi.zdyxjx.com/
const baseURL =   process.env.VUE_APP_BASE_API;
var createTimestamp = function () {
    return parseInt(new Date().getTime() / 1000) + '';
  };

// 添加请求拦截器，在发送请求之前做些什么(**具体查看axios文档**)--------------------------------------------
axios.interceptors.request.use(config => {

        // 显示loading
        return config
    },
    error => {
        // 请求错误时弹框提示，或做些其他事
        console.log(error) // for debug
        return Promise.reject(error)
    })
 
// 添加响应拦截器(**具体查看axios文档**)----------------------------------------------------------------
axios.interceptors.response.use(response => {
    // 对响应数据做点什么，允许在数据返回客户端前，修改响应的数据
    // 如果只需要返回体中数据，则如下，如果需要全部，则 return response 即可
    return response

}, err => {
    console.log(err)

    // 对响应错误做点什么
    if (err && err.response) {
        switch (err.response.status) {
            case 400:
                console.log('错误请求');
                break;
            case 401:
                console.log('未授权，请重新登录');
                break;
            case 403:
                console.log('拒绝访问');
                break;
            case 404:
                console.log('请求错误,未找到该资源');
                break;
            case 405:
                console.log('请求方法未允许');
                break;
            case 408:
                console.log('请求超时');
                break;
            // case 500:
            //     console.log('服务器端出错');
                break;
            case 501:
                console.log('网络未实现');
                break;
            case 502:
                console.log('网络错误');
                break;
            case 503:
                console.log('服务不可用');
                break;
            case 504:
                console.log('网络超时');
                break;
            case 505:
                console.log('http版本不支持该请求');
                break;
            default:

                console.log(err.response)
                console.log(`连接错误${err.response.status}`)
        }
    } else {
        console.log('连接到服务器失败')
    }
    return Promise.resolve(err)
    // return Promise.reject(error)
});
 
// 封装axios--------------------------------------------------------------------------------------
function http(method, url, isForm, params,dataText) {

    let paramsObject = params;
    if (params && params.params) {
        paramsObject = params.params;
    }
    let httpDefault = {
        method: method,
        baseURL: baseURL,
        url: url,
        params: method === 'GET' || method === 'DELETE' ? paramsObject : null,// `params` 是即将与请求一起发送的 URL 参数
        // qs.stringify(params) : null,//qs转换,json字符串转换，直接传对象，三种方法请根据实际情况使用
        data: method === 'POST' || method === 'PUT' || method === 'PATCH' ? qs.stringify(paramsObject) : null,// `data` 是作为请求主体被发送的数据
        timeout: 10000,
        crossDomain: true
    };
    // console.log(dataText)
    // console.log(paramsObject) 
    // console.log('sign :' , paramData(dataText) + 'NJc72X59JOTMUKDBEfzxt4rWzpw'+ createTimestamp())
    // console.log('Md5sign :' , md5(paramData(dataText) + 'NJc72X59JOTMUKDBEfzxt4rWzpw'+ createTimestamp()))
    // console.log('userId1 :' , Lockr.get("userId"))
    // console.log('userId2 :' , store.getters.userId)
    // console.log('userId3 :' , store.state.admin.userId)
    // console.log(store.getters.token ,getToken()) 
    console.log(store.getters)
    // if(store.getters.token){
        httpDefault.headers = {
            // 'Content-Type': 'application/json', //application/x-www-form-urlencoded 
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            timestamp: createTimestamp(), // 当前时间戳
            sign: md5(paramData(dataText) + 'NJc72X59JOTMUKDBEfzxt4rWzpw'+ createTimestamp()), // md5( 键名=键值键名=键值+密钥+时间戳)（post参数， 按照键名升序排列 拼接 例如：md5( k=vk1=v1fzxc72XNJJOTMUKDBE59t4rWzpw1615962120) )
            uid: Lockr.get("userId") || store.getters.userId || store.state.admin.userId, //登录返回的用户id
        };
        if(isForm){//如果是formData格式的，使用这个请求头
            httpDefault.headers = {
                'Content-Type': 'multipart/form-data',
                timestamp: createTimestamp(), // 当前时间戳
                sign: md5(paramData(dataText) + 'NJc72X59JOTMUKDBEfzxt4rWzpw'+ createTimestamp()), // md5( 键名=键值键名=键值+密钥+时间戳)（post参数， 按照键名升序排列 拼接 例如：md5( k=vk1=v1fzxc72XNJJOTMUKDBE59t4rWzpw1615962120) )
                uid: Lockr.get("userId") || store.getters.userId || store.state.admin.userId, //登录返回的用户id
            };
            httpDefault.data = paramsObject
        }
    // }else{
    //     httpDefault.headers = {
    //         'X-Req-From': 'WxMp',
    //         'X-Channel-Code': 'ZDYX',
    //         'Content-Type': 'application/json',
    //         Token:'',// getToken() || store.getters.token || //可以在登录那里填充，也可以用vuex填充，也可以在config.js中获取在放过来
    //     };
    //     if(isForm){//如果是formData格式的，使用这个请求头
    //         httpDefault.headers = {
    //             'X-Req-From': 'WxMp',
    //             'X-Channel-Code': 'ZDYX',
    //             'Content-Type': 'multipart/form-data',
    //             Token: ''
    //         };
    //     }
    // }
  
 
    // 注意**Promise**使用(Promise首字母大写)
    return new Promise((resolve, reject) => {
        axios(httpDefault)
        // 此处的.then属于axios
            .then((res) => {
                resolve(res);
            }).catch((response) => {
            
            reject(response);
        })
    })
}

function paramData(json) {
    // console.log(json,'12345')
    if (!json) return ''
    return cleanArray(
      Object.keys(json).map(key => {
        if (json[key] === undefined) return '' 
        return key + '=' + json[key]
      })
    ).join('')
  }
  /**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
    const newArray = []
    for (let i = 0; i < actual.length; i++) {
      if (actual[i]) {
        newArray.push(actual[i])
      }
    }
    return newArray.sort();
  } 
// 输出函数getAxios、postAxios、putAxios、delectAxios，供其他文件调用-----------------------------
// Vue.js的插件应当有一个公开方法 install。这个方法的第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象。
export default {
    install: function (Vue) {
        Vue.prototype.$get = (url, params) => http('GET', url,false, params);
        Vue.prototype.$post = (url, params,dataText) => http('POST', url, false,params,dataText);
        Vue.prototype.$postForm = (url, params,dataText) => http('POST', url, true,params,dataText);
        Vue.prototype.$put = (url, params) => http('PUT', url,false, params);
        Vue.prototype.$delete = (url, params) => http('DELETE', url, false,params);
        Vue.prototype.$patch = (url, params) => http('PATCH', url,false, params);
    }
}